const getUpdatedUrlWithQueryParams = (params)=>{
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    params && Object.keys(params).forEach((key)=>{
        params[key] && urlParams.set(key, `${params[key]}`);
    });
    return url.toString();
};
const appendQueryParamToUrl = (path, params)=>{
    const url = new URL(`${window.location.origin}${path}`);
    const urlParams = url.searchParams;
    params && Object.keys(params).forEach((key)=>{
        params[key] && urlParams.set(key, `${params[key]}`);
    });
    return url.toString();
};
const removeQueryParamsFromUrl = (params)=>{
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    params.forEach((paramKey)=>{
        urlParams.delete(paramKey);
    });
    return url.toString();
};

export { appendQueryParamToUrl, getUpdatedUrlWithQueryParams, removeQueryParamsFromUrl };
//# sourceMappingURL=get-updated-url-with-query-params.js.map
